import { listarPendenciasPagamentoExterior } from './pagamentoExteriorPolicy';
import { listarPendenciasRemessaExterior } from './remessaExteriorEstimativaPolicy';
import { listarPendenciasFechamentoExterior } from './fechamentoExteriorPolicy';
import { listarPendenciasMoedaFornecedor } from './moedaFornecedorPolicy';

const numero = (valor) => {
    if (valor === null || valor === undefined || String(valor).trim() === '') return null;
    const texto = String(valor).trim();
    const convertido = Number(texto.includes(',') ? texto.replace(/\./g, '').replace(',', '.') : texto);
    return Number.isFinite(convertido) ? convertido : null;
};

// Cada erro traz `alvo` = { grupoIndex, linhaIndex, etapa, campo } quando aponta para um campo da
// grade (item 13): o alerta mostra um "Mostrar campo" por erro. Câmbio não tem alvo (tem modal
// próprio). Todas as pendências de cada tipo entram (não só a primeira), na ordem da grade.
export function validarDadosInternacionais(orcamento = {}, fornecedorAccess = null) {
    const erros = [];
    const moeda = String(orcamento.moeda || 'real').toLowerCase();
    const cambio = numero(orcamento.cambio);
    if (moeda !== 'real' && (cambio === null || cambio <= 0)) {
        erros.push({ tipo: 'cambio', mensagem: 'Informe um câmbio válido para a moeda selecionada.', alvo: null });
    }
    [
        ['pagamento', listarPendenciasPagamentoExterior],
        ['moeda_fornecedor', listarPendenciasMoedaFornecedor],
        ['remessa', listarPendenciasRemessaExterior],
        ['fechamento', listarPendenciasFechamentoExterior],
    ].forEach(([tipo, listar]) => {
        listar(orcamento, fornecedorAccess).forEach(({ mensagem, ...alvo }) => erros.push({ tipo, mensagem, alvo }));
    });
    return erros;
}

// Coluna de etapa da grade que precisa estar expandida para o campo do alvo existir no DOM.
// O Local do pagamento fica na célula do fornecedor, sempre visível: sem coluna.
export const COLUNA_ETAPA_ALVO = { pre: 'Pré-evento', neg: 'Negociado', fechamento: 'Fechamento' };

export function etapaColunaDoAlvo(alvo) {
    return alvo && Object.prototype.hasOwnProperty.call(COLUNA_ETAPA_ALVO, alvo.etapa) ? alvo.etapa : null;
}

// `visiveis` = { pre: showPreEvento, neg: showNegociado, fechamento: showFechamento }.
export function alvoEmColunaRecolhida(alvo, visiveis = {}) {
    const etapa = etapaColunaDoAlvo(alvo);
    return etapa !== null && !visiveis[etapa];
}

// Mesmos ids renderizados no CadastroOrcamento (renderConfiguracaoRemessaLinha / Local do pagamento).
export function idCampoAlvoInternacional(alvo) {
    if (!alvo || !Number.isInteger(alvo.grupoIndex) || !Number.isInteger(alvo.linhaIndex)) return null;
    const posicao = `${alvo.grupoIndex}-${alvo.linhaIndex}`;
    if (alvo.campo === 'local_pagamento') return `local-pagamento-${posicao}`;
    // D-0121: seletor do Sub Item da linha.
    if (alvo.campo === 'sub_item') return `sub-item-${posicao}`;
    // Observação obrigatória (21/10): input da observação da etapa na linha.
    if (alvo.campo === 'observacao' && etapaColunaDoAlvo(alvo)) return `observacao-${alvo.etapa}-${posicao}`;
    if (alvo.campo === 'fechamento_exterior') return `fechamento-exterior-${posicao}`;
    if (alvo.campo === 'moeda_fornecedor') return `moeda-fornecedor-${posicao}`;
    if (['cambioPreEvento', 'cambioNegociado', 'cambioFechamento'].includes(alvo.campo)) return `${alvo.campo}-fornecedor-${posicao}`;
    if (etapaColunaDoAlvo(alvo) && alvo.campo) return `remessa-${alvo.etapa}-${alvo.campo}-${posicao}`;
    return null;
}

// Texto anexado ao erro quando o campo está numa coluna recolhida (o componente põe um espaço antes).
export function textoColunaRecolhida(alvo, visiveis = {}) {
    return alvoEmColunaRecolhida(alvo, visiveis) ? `(coluna ${COLUNA_ETAPA_ALVO[alvo.etapa]} recolhida)` : null;
}

// O alerta fica fixo acima do rodapé: com muitas pendências ele cobriria a grade. Mostra as
// primeiras `limite` e resume o resto (aparecem conforme as de cima são corrigidas).
export const LIMITE_ERROS_ALERTA = 6;
export function errosVisiveisNoAlerta(erros = [], limite = LIMITE_ERROS_ALERTA) {
    return { visiveis: erros.slice(0, limite), ocultos: Math.max(0, erros.length - limite) };
}
